module.exports = __webpack_public_path__ + "cf2a0c1f2.png";